function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v10H0V5Z",
    style: {
      fill: "#ed2939"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.336,
    cy: 10,
    r: 3.681,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.003,
    cy: 10,
    r: 3.681,
    style: {
      fill: "#ed2939"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.35,6.931l-.563,1.733,1.475-1.071h-1.824l1.475,1.072-.563-1.734Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M11.269,9.052h-1.823l1.474,1.072-.563-1.734-.563,1.734,1.475-1.072Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M6.546,12.483l1.475-1.071h-1.823l1.475,1.072-.563-1.734-.564,1.733Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M10.154,12.483l-.563-1.733-.564,1.734,1.475-1.072h-1.823l1.475,1.071Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M5.431,9.052l1.474,1.071-.563-1.734-.563,1.734,1.475-1.072h-1.823Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/SG.c549ff74abd3075107337b9d18ac21b8.svg";
export { ForwardRef as ReactComponent };